<template>
  <div
    ref="zjdgx"
    class="commissions"
  >
    <div class="bread-crumb">
      Commissions
    </div>
    <h2>Commissions</h2>
    <div class="content">
      <a-spin :spinning="isLoading">
        <div class="filter">
          <a-form
            class="filter"
            :model="filter"
            @submit="searchCommission()"
          >
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="UserID">
                  <a-input
                    v-model:value="filter.influencerId"
                    placeholder="Please enter"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Username">
                  <a-auto-complete
                    v-model:value="filter.influencerUsername"
                    :allow-clear="true"
                    placeholder="Please enter"
                    :options="userSuggestions"
                    @select="onUserSelect"
                    @keydown.enter.stop="changeUser"
                    @clear="clearUser"
                    @search="onUserSearch"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Advertiser Id">
                  <a-input
                    v-model:value="filter.advertiserId"
                    placeholder="Please enter"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="Advertiser Name">
                  <a-select
                    v-model:value="advertiserState.value"
                    show-search
                    allow-clear
                    class="advertiser-select"
                    placeholder="Please enter"
                    :filter-option="false"
                    :not-found-content="
                      advertiserState.fetching ? undefined : null
                    "
                    :options="advertiserState.data"
                    :get-popup-container="
                      (triggerNode) => {
                        return triggerNode.parentNode
                      }
                    "
                    @blur="advertiserBlur"
                    @clear="clearAdvertiser"
                    @select="onAdvertiserSelect"
                    @search="onAdvertiserSearch"
                  >
                    <template
                      v-if="advertiserState.fetching"
                      #notFoundContent
                    >
                      <a-spin size="small" />
                    </template>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="ID">
                  <a-input
                    v-model:value="id"
                    placeholder="Please enter"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Affiliate">
                  <a-select
                    v-model:value="filter.affiliateId"
                    placeholder="Select"
                    allow-clear
                    :options="affiliateList"
                    @change="searchCommission"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="10">
                <a-form-item label="Event Time">
                  <a-range-picker
                    v-model:value="filterDate"
                    :style="{ width: '300px' }"
                    :disabled-date="disabledDate"
                    format="YYYY-MM-DD HH:mm"
                    :allow-clear="true"
                    :placeholder="['Start date', 'End date']"
                    @change="setFilterDate"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item
              label="Status"
              class="checkbox-list"
            >
              <a-checkbox
                v-model:checked="statusReactive.checkAll"
                :indeterminate="statusReactive.indeterminate"
                @click="(e) => toggleAll(e, 'status')"
              >
                All
              </a-checkbox>
              <a-checkbox-group
                v-model:value="statusReactive.checkedList"
                :options="statusReactive.options"
                :indeterminate="statusReactive.indeterminate"
              />
            </a-form-item>
            <a-row>
              <a-col :span="12">
                <a-form-item
                  label="Type"
                  class="checkbox-list"
                >
                  <a-checkbox
                    v-model:checked="typeReactive.checkAll"
                    :indeterminate="typeReactive.indeterminate"
                    @click="(e) => toggleAll(e, 'type')"
                  >
                    All
                  </a-checkbox>
                  <a-checkbox-group
                    v-model:value="typeReactive.checkedList"
                    :options="typeReactive.options"
                    :indeterminate="typeReactive.indeterminate"
                  />
                </a-form-item>
              </a-col>
              <a-col
                :span="12"
                class="btns"
              >
                <a-button
                  type="primary"
                  html-type="submit"
                >
                  Search
                </a-button>
                <a-button @click="resetFilter">
                  Reset
                </a-button>
                <a
                  :href="`https://${apiDomain}/admin/influencer-marketing/v1/commissions/list/export${filterDate && filterDate[0] ? `?beginTime=${filterDate[0]?.valueOf()}&endTime=${filterDate[1]?.valueOf()}` : ''}`"
                  download
                ><a-button type="primary">Export</a-button></a>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <div class="statistic">
          <div
            v-for="(item, index) in commissionStatistic"
            :key="index"
            class="statistic-item"
          >
            <span class="total">${{ item['value'] }}</span>
            <span class="statistic-key">{{ item['title'] }}</span>
            <span class="statistic-type">{{ item['type'] }}</span>
          </div>
        </div>
        <div class="commission-table">
          <a-table
            :data-source="commissionList"
            :columns="columns()"
            :scroll="{ x: 4903 }"
            size="small"
            :show-sorter-tooltip="false"
            :pagination="commissionPagination"
            :row-class-name="commissionRowClassName"
            @change="sortCommission"
          >
            <template #headerCell="{ column }">
              <template v-if="column.titleTip">
                <TableTitlePopover
                  :title="column.key"
                  :content="column.titleTip"
                />
              </template>
            </template>
            <template #bodyCell="{ column, record, index }">
              <template
                v-if="
                  column.dataIndex === 'eventTime' ||
                    column.dataIndex === 'updateTime'
                "
              >
                {{
                  moment(record[column.dataIndex]).format('YYYY-MM-DD HH:mm:ss')
                }}
              </template>
              <template
                v-else-if="
                  column.dataIndex === 'salesUsd' ||
                    column.dataIndex === 'commissionUsd' ||
                    column.dataIndex === 'originalSales' ||
                    column.dataIndex === 'originalCommission'
                "
              >
                <span
                  :class="
                    (column.dataIndex === 'commissionUsd' ||
                      column.dataIndex === 'originalCommission') &&
                      record['commissionNotEqual']
                      ? 'red-mark'
                      : ''
                  "
                >{{
                 record[column.dataIndex]
                }}</span>
              </template>
              <template v-else-if="column.dataIndex === 'cancelSales' || column.dataIndex === 'cancelCommission'">
                {{ Number(record[column.dataIndex])? record[column.dataIndex]:'N/A'}}
              </template>
              <template v-else-if="column.dataIndex === 'cancelReason'">
                <a-tooltip v-if="record.cancelReason" :title="record.cancelReason">
                  <span class="cancel-reason-ellipsis">{{ record.cancelReason }}</span>
                </a-tooltip>
                <template v-else>--</template>
              </template>
              <template v-else-if="column.key === 'Inrwd Link'">
                <a
                  :href="record.shortLink"
                  target="_blank"
                >{{
                  record.shortLink
                }}</a>
              </template>
              <template v-else-if="column.key === 'Status'">
                <span :class="record.status.replace(' ', '-').toLowerCase()">{{
                  record.status
                }}</span>
              </template>
              <template v-else-if="column.key === 'Note'">
                <div
                  v-if="record.note?.length"
                  class="note"
                >
                  {{ record.note }}
                  <a
                    href="javascript:;"
                    @click.stop="(e) => setNoteEditModal(e, index, record.note)"
                  >Edit</a>
                </div>
                <div
                  v-else
                  @click.stop="(e) => setNoteEditModal(e, index, '')"
                >
                  <a-textarea
                    :rows="2"
                    value=""
                    :style="{ 'pointer-events': 'none' }"
                    placeholder="Click to enter"
                  />
                </div>
              </template>
              <template v-else-if="column.key === 'actions'">
                <div class="actions">
                  <a
                    class="view"
                    href="javascript:;"
                    @click="showCommissionDetailModal(index, record)"
                  >View</a>
                  <a
                    class="log"
                    href="javascript:;"
                    @click="setShowLogModalId(record.id)"
                  >Log</a>
                </div>
              </template>
            </template>
          </a-table>
          <div
            v-if="showNoteEditModal"
            v-click-outside="hideNoteEditModal"
            class="note-edit-container"
            :style="{ ...noteEditPosition }"
          >
            <a-textarea
              v-model:value="newNoteContent"
              :rows="2"
              autofocus
              placeholder="Click to enter"
            />
            <a-button
              type="primary"
              :style="{ height: noteEditPosition.height }"
              @click="
                saveNote(
                  commissionList[noteEditCommissionIndex].id,
                  noteEditCommissionIndex,
                  newNoteContent
                )
              "
            >
              Done
            </a-button>
          </div>
        </div>
      </a-spin>
    </div>
    <a-modal
      v-model:open="showLogModal"
      title="Log"
      class="log-modal"
      :width="1000"
      :footer="null"
      :mask-style="{ zIndex: 1001 }"
      wrap-class-name="log-modal-wrapper"
      :get-container="$refs.zjdgx"
      @ok="hideLogModal"
      @cancel="hideLogModal"
    >
      <a-spin :spinning="logLoading">
        <a-table
          :data-source="logList"
          :columns="LogTableColumns"
          bordered
          :pagination="logPagination"
          :scroll="{ y: 480 }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'createTime'">
              {{ moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </template>
        </a-table>
      </a-spin>
    </a-modal>
    <CommissionDetailModal
      v-if="commissionModal.detail"
      ref="commissionDetailModalRef"
      :container="$refs.zjdgx"
      :commission="commissionModal.detail"
      :commission-index="commissionModal.index"
      @saveNote="saveNote"
      @setShowLogModalId="setShowLogModalId"
      @hideCommissionDetailModal="hideCommissionDetailModal"
    />
  </div>
</template>

<script setup>
import moment from 'moment'
import { debounce } from 'lodash-es'
import { message } from 'ant-design-vue'
import { apiDomain } from '../../../config'
import { ref, reactive, watch } from 'vue'
import { TABLE_COLUMNS, getElementPosition } from './utils'
import { user, advertiser, commissions } from '../../server/index'
import TableTitlePopover from '../../components/tableTitlePopover.vue'
import CommissionDetailModal from './detailModal.vue'
import vClickOutside from '../../../directives/click-outside.js'

const idMatch = location.hash.match(new RegExp(`[?&]id=([^&]+)`));
const id = ref(idMatch ? idMatch[1] : undefined)
const isLoading = ref(true)
const filterDate = ref([moment().subtract(365, 'days').startOf('date'), moment().endOf('date')])

/** 日期区间 / 最早可选：两年 */
const COMMISSION_MAX_RANGE_DAYS = 365 * 2
const filter = ref({
  page: 1,
  size: 200,
  influencerId: null,
  influencerUsername: null,
  influencerSuggestionId: null,
  advertiserId: null,
  advertiserSuggestionId: null,
  id: id.value,
  affiliateId: null,
  beginTime: filterDate.value[0].startOf('date').valueOf(),
  endTime: filterDate.value[1].endOf('date').valueOf(),
  status: [
    'Open',
    'DM Received',
    'Pending Payment',
    'Declined',
    'Paid',
  ],
  type: ['Sale', 'Returned', 'Rejected', 'Adjust'],
  sort: '-eventTime',
})
let oldSearchParams = JSON.stringify(filter.value)
let influencerUsernameInputTriggeredSelect = false
const sorterInfo = ref({
  columnKey: 'Event Time',
  order: 'descend',
})
const columns = () =>
  TABLE_COLUMNS.map((item) => {
    if (
      [
        'eventTime',
        'updateTime',
        'salesUsd',
        'commissionUsd',
        'commissionForKolUsd',
        'commissionForKolRatio',
      ].indexOf(item.dataIndex) !== -1
    ) {
      return {
        ...item,
        sorter: true,
        sortOrder:
          sorterInfo.value.columnKey == item.key && sorterInfo.value.order,
      }
    } else {
      return item
    }
  })
const showLogId = ref(-1)
const affiliateList = ref([])
const commissionPagination = ref({
  current: 1,
  pageSize: 200,
  total: 0,
  showSizeChanger: false,
  onChange: (page) => {
    filter.value.page = page
    getCommissionList()
  },
})

const logList = ref([])
const commissionList = ref([])
const commissionStatistic = ref(null)
const statusReactive = reactive({
  indeterminate: false,
  checkAll: true,
  checkedList: [
    'Open',
    'DM Received',
    'Pending Payment',
    'Declined',
    'Paid',
  ],
  options: [
    'Open',
    'DM Received',
    'Pending Payment',
    'Declined',
    'Paid',
  ],
})
const typeReactive = reactive({
  indeterminate: false,
  checkAll: true,
  checkedList: ['Sale', 'Returned', 'Rejected', 'Adjust'],
  options: ['Sale', 'Returned', 'Rejected', 'Adjust'],
})

const commissionRowClassName = (record) => {
  return record?.commissionNotEqual ? 'commission-not-equal-row' : ''
}

watch(
  () => statusReactive.checkedList,
  (val) => {
    filter.value.status = statusReactive.checkedList
    statusReactive.indeterminate =
      !!val.length && val.length < statusReactive.options.length
    statusReactive.checkAll = val.length === statusReactive.options.length
  }
)

watch(id, (val) => {
  if (val && /\d+/.test(val)) {
    filter.value.id = val
    location.hash = `#/commissions?id=${val}`
  } else {
    location.hash = '#/commissions'
  }
})

watch(
  () => typeReactive.checkedList,
  (val) => {
    filter.value.type = typeReactive.checkedList
    typeReactive.indeterminate =
      !!val.length && val.length < typeReactive.options.length
    typeReactive.checkAll = val.length === typeReactive.options.length
  }
)

function toggleAll(e, type) {
  Object.assign(type == 'type' ? typeReactive : statusReactive, {
    checkedList: (e.target ? e.target.checked : e)
      ? type == 'type'
        ? typeReactive.options
        : statusReactive.options
      : [],
    indeterminate: false,
  })
}

advertiser.getAffiliateList().then((res) => {
  if (res.success) {
    affiliateList.value = res.data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      }
    })
  } else {
    message.error(`Failed to get the list of affiliate, please try again.`)
  }
})

function getCommissionList() {
  const params = { ...filter.value }

  Object.keys(filter.value).forEach((key) => {
    if (!params[key]) {
      delete params[key]
    } else if (key == 'influencerSuggestionId') {
      delete params['influencerUsername']
    }
  })
  isLoading.value = true

  commissions.getList(params).then((res) => {
    isLoading.value = false
    commissionList.value = res.data
    commissionPagination.value.current = filter.value.page
    if (filter.value.page === 1) {
      commissionPagination.value.total = res.total
    }
  })
}

function getCommissionStatistic() {
  const params = { ...filter.value }

  Object.keys(filter.value).forEach((key) => {
    if (!params[key]) {
      delete params[key]
    } else if (key == 'influencerSuggestionId') {
      delete params['influencerUsername']
    }
  })
  commissions.statistic(params).then((res) => {
    if (res.success) {
      commissionStatistic.value = Object.keys(res.data).map((key) => {
        let title = key.replace(/([A-Z])/g, ' $1').split(' ')
        const type = title.splice(-1)

        title = title
          .map((item) => (item.toLowerCase() === 'kol' ? 'KOL' : item))
          .join(' ')

        title = title.charAt(0).toUpperCase() + title.slice(1)

        return {
          type: type[0] == 'History' ? 'All History' : type[0],
          title,
          value: res.data[key],
        }
      })
    }
  })
}

getCommissionList()
getCommissionStatistic()

function searchCommission() {
  if (oldSearchParams != JSON.stringify(filter.value)) {
    filter.value.page = 1
    oldSearchParams = JSON.stringify(filter.value)
    getCommissionList()
    getCommissionStatistic()
  }
}

// Event Time
function setFilterDate(values) {
  if (values) {
    filter.value.beginTime = values[0].startOf('date').valueOf()
    filter.value.endTime = values[1].endOf('date').valueOf()
  } else {
    filter.value.beginTime = null
    filter.value.endTime = null
  }
}
function disabledDate(current) {
  if (!current) return false
  const maxEnd = moment().endOf('date')
  const minStart = moment().subtract(2, 'years').startOf('date')
  // 超过两年前 / 晚于今天，不可选
  if (current.isBefore(minStart, 'day') || current.isAfter(maxEnd, 'day')) {
    return true
  }
  if (!filterDate.value || filterDate.value.length === 0) {
    return false
  }
  const tooLate =
    filterDate.value[0] &&
    current.diff(filterDate.value[0], 'days') > COMMISSION_MAX_RANGE_DAYS
  const tooEarly =
    filterDate.value[1] &&
    filterDate.value[1].diff(current, 'days') > COMMISSION_MAX_RANGE_DAYS

  return !!(tooEarly || tooLate)
}

function resetFilter() {
  advertiserState.data = []
  advertiserState.value = null
  toggleAll(true, 'type')
  toggleAll(true, 'status')
  sorterInfo.value = {
    columnKey: 'Event Time',
    order: 'descend',
  }
  id.value = undefined
  filterDate.value = [moment().subtract(365, 'days').startOf('date'), moment().endOf('date')]
  filter.value = {
    page: 1,
    size: 200,
    influencerId: null,
    influencerUsername: null,
    influencerSuggestionId: null,
    advertiserId: null,
    advertiserSuggestionId: null,
    id: null,
    affiliateId: null,
    beginTime: filterDate.value[0].startOf('date').valueOf(),
    endTime: filterDate.value[1].endOf('date').valueOf(),
    status: [
      'Open',
      'DM Received',
      'Pending Payment',
      'Declined',
      'Paid',
    ],
    type: ['Sale', 'Returned', 'Rejected', 'Adjust'],
    sort: '-eventTime',
  }
  searchCommission()
}

function sortCommission(pagination, filters, sorter, { action }) {
  if (action === 'sort') {
    if (filter.value.sort.indexOf(sorter.field) != -1) {
      filter.value.sort =
        (filter.value.sort.startsWith('-') ? '%2B' : '-') + sorter.field
      sorterInfo.value.order = filter.value.sort.startsWith('-')
        ? 'descend'
        : 'ascend'
    } else {
      sorterInfo.value.order = 'descend'
      filter.value.sort = '-' + sorter.field
    }

    sorterInfo.value.columnKey = sorter.columnKey
    searchCommission()
  }
}

// influencerUsername搜索
const userSuggestions = ref([])
function onUserSearch(value) {
  value = value.trim()
  user
    .getSuggestionList('userName', {
      userName: value,
      size: 20,
    })
    .then((res) => {
      if (res.success) {
        userSuggestions.value = res.data.map((item) => {
          return { label: item.userName, value: item.id }
        })
      }
    })
}
function onUserSelect(id, option) {
  if (userSuggestions.value.length) {
    filter.value.influencerSuggestionId = id
    filter.value.influencerUsername = option.label
    influencerUsernameInputTriggeredSelect = true
    searchCommission()
  } else {
    filter.value.influencerSuggestionId = null
    influencerUsernameInputTriggeredSelect = false
  }
}

// 先触发change, 再触发select, 所以可以先把influencerSuggestionId设为null
// function onUserChange(value) {
//   console.log(`----[onUserChange]value: ${value}----`)
//   filter.value.influencerUsername = value
//   filter.value.influencerSuggestionId = null
// }

function changeUser(e) {
  if (!influencerUsernameInputTriggeredSelect) {
    influencerUsernameInputTriggeredSelect = false
    filter.value.influencerUsername = e.target.value.trim()
  }
}

function clearUser() {
  filter.value.influencerUsername = null
  filter.value.influencerSuggestionId = null
  influencerUsernameInputTriggeredSelect = false
  searchCommission()
}

// 弹窗显示commission
const commissionDetailModalRef = ref(null)
const commissionModal = ref({
  index: -1,
  detail: null,
})
function showCommissionDetailModal(index, commissionItem) {
  commissionModal.value.index = index
  commissionModal.value.detail = commissionItem
}
function hideCommissionDetailModal() {
  commissionModal.value.index = -1
  commissionModal.value.detail = null
}

// log相关代码
const logLoading = ref(false)
const showLogModal = ref(false)
const LogTableColumns = [
  { title: 'Editor', dataIndex: 'editorName', key: 'editorName' },
  { title: 'Operation', dataIndex: 'operation', key: 'operation' },
  { title: 'Date', dataIndex: 'createTime', key: 'createTime' },
]
const logPagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: false,
  onChange: (page) => {
    getLog(page)
  },
})
function getLog(page) {
  logLoading.value = true
  commissions
    .getLogList({
      id: showLogId.value,
      page,
      size: 10,
    })
    .then((res) => {
      logLoading.value = false

      if (res.success) {
        logList.value = res.data

        if (page == 1) {
          logPagination.value.total = res.total
        }

        logPagination.value.current = page
      }
    })
}
function setShowLogModalId(id) {
  showLogId.value = id
  showLogModal.value = true
  getLog(1)
}
function hideLogModal() {
  showLogId.value = -1
}

// note相关
const newNoteContent = ref('')
const noteEditPosition = ref(null)
const showNoteEditModal = ref(false)
const noteEditCommissionIndex = ref(-1)

function hideNoteEditModal() {
  newNoteContent.value = ''
  showNoteEditModal.value = false
}

function setNoteEditModal(event, index, note) {
  const $cell = event.target.closest('.ant-table-cell')
  const pos = getElementPosition(
    $cell,
    document.querySelector('.commission-table')
  )
  newNoteContent.value = note
  noteEditCommissionIndex.value = index

  noteEditPosition.value = { ...pos, height: $cell.offsetHeight - 3 + 'px' }
  showNoteEditModal.value = true
}

function saveNote(id, index, content) {
  content = content.trim()

  if (commissionList.value[index].note != content) {
    isLoading.value = true

    commissions
      .saveNote({
        id,
        note: content,
      })
      .then((res) => {
        isLoading.value = false

        if (res.success) {
          showNoteEditModal.value = false
          commissionList.value[index].note = content

          if (commissionModal.value.detail) {
            commissionDetailModalRef.value.hideNoteEditModal()
          }
        } else {
          message.error('保存失败，请稍后再试')
        }
      })
  } else {
    hideNoteEditModal()
  }
}

// advertiser搜索
let lastFetchId = 0
const advertiserState = reactive({
  data: [],
  value: null,
  fetching: false,
})
function onAdvertiserSelect(id) {
  filter.value.advertiserSuggestionId = id
  searchCommission()
}
function advertiserBlur() {
  advertiserState.data = []
}
function clearAdvertiser() {
  filter.value.advertiserSuggestionId = null
  searchCommission()
}
const onAdvertiserSearch = debounce((value) => {
  if (value.trim().length) {
    lastFetchId += 1
    const fetchId = lastFetchId
    advertiserState.data = []
    advertiserState.fetching = true
    advertiser
      .getSuggestionList({
        name: value,
        size: 20,
      })
      .then((res) => {
        if (fetchId !== lastFetchId) {
          return
        }

        if (res.success) {
          advertiserState.data = res.data.map((item) => {
            return { label: item.advertiserName, value: item.id }
          })
        }

        advertiserState.fetching = false
      })
  } else {
    advertiserState.data = []
  }
}, 300)
watch(advertiserState.value, () => {
  advertiserState.data = []
  advertiserState.fetching = false
})
</script>

<style lang="less" scoped>
@import './common.less';

.commissions {
  :deep(.ant-modal) {
    .ant-table {
      &-container {
        border-inline-start: none !important;
      }
      table {
        border-top: none !important;
      }
      &-cell:last-of-type {
        border-inline-end: none !important;
      }
    }
  }
  :deep(.log-modal-wrapper) {
    z-index: 1001 !important;
  }
  .red-mark {
    color: #ff4d4f;
  }
  .commission-table :deep(tr.commission-not-equal-row > td) {
    background: #FCE5E7;
  }
}
.content {
  padding: 20px;
  min-width: unset;
  margin-bottom: 20px;
}
.filter {
  :deep(.ant-form-item-row) {
    width: 100%;
  }
  .btns {
    display: flex;
    justify-content: right;
    :deep(.ant-btn) {
      margin-left: 20px;
    }
  }
  .checkbox-list {
    :deep(.ant-checkbox-wrapper) {
      margin-right: 12px;
      .ant-checkbox + span {
        padding-inline-start: 4px;
      }
    }
  }
}
.ant-form-item {
  display: flex;
  :deep(&-label) {
    width: 148px;
    color: #ff285a;
  }
}
.statistic {
  margin-bottom: 24px;
  &-item {
    padding: 10px;
    text-align: center;
    margin-right: 10px;
    border-radius: 6px;
    display: inline-block;
    background: #f2f2f2;
  }
  .total {
    font-size: 20px;
    font-weight: 500;
  }
  &-key {
    display: block;
    font-size: 12px;
    color: #666;
    margin-top: 4px;
    line-height: 12px;
  }
  &-type {
    color: #999;
    font-size: 12px;
    line-height: 12px;
    display: block;
    margin-top: 2px;
  }
}
.commission-table {
  position: relative;
  .note {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .cancel-reason-ellipsis {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.commission-id {
  display: block;
  min-height: 30px;
}
.advertiser-select {
  :deep(.ant-select-item-empty) {
    text-align: center;
  }
}
</style>